module.exports = __webpack_public_path__ + "static/media/gryphon-nova_projects-page.fd3a15bc.jpg";